module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tab', {
    staticClass: "g-header",
    attrs: {
      "line-width": 0
    }
  }, [_c('tab-item', {
    staticClass: "router-link",
    on: {
      "on-item-click": _vm.changePage
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'session'
      }
    }
  }, [_vm._v("最近消息")])], 1), _vm._v(" "), _c('tab-item', {
    staticClass: "router-link",
    on: {
      "on-item-click": _vm.changePage
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contacts'
      }
    }
  }, [_vm._v(_vm._s(_vm.contactsText))])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34a7db7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a7db7c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/NavBar.vue
// module id = 260
// module chunks = 18